import * as React from 'react';
import {Field, reduxForm, InjectedFormProps} from 'redux-form';
import {connect} from 'react-redux';
import {Validators, DatePickerField, SelectField} from './Fields/_Fields';
import {ValidatorsTerminalls} from './Fields/ValidatorsTerminalls';
import TimePickerField from './Fields/TimePickerField';
import * as Dictionary from 'Models/Dictionary';
import * as UserModule from 'Modules/UserModule';
import {withTranslation} from 'react-i18next';
import {RootState} from 'Redux/Reducers/_RootReducer';
import {TerminalInstallationSelectors} from 'Redux/Selectors/TerminalInstallationSelectors';
import {compose} from 'redux';

type ConnectedProps = {
    t: Function;
    responseError: {
        errorCode: string;
        errorSubcode: string;
    };
    terminalFitterList: Array<UserModule.Types.UserDto>;
    selectedEl: any;
    installationDateForm: any;
};

type ConnectedDispatch = {
    getUserList: (queryParams?: Array<{ key: any; value: any }>) => Function;
    getUserById: (id: number) => Function;
};

type Props = {
    typeForm: 'edit' | 'add' | 'setDate';
};

class TerminalInstallationListSetDateForm extends React.Component<InjectedFormProps & ConnectedProps & Props & ConnectedDispatch, any> {

    public render() {
        const {handleSubmit, t, terminalFitterList, installationDateForm} = this.props;

        const hasSelectedDate = installationDateForm != undefined && installationDateForm.values != undefined ? installationDateForm.values.installationDate?.isValid() : false;

        return (
            <form className="form" onSubmit={handleSubmit}>
                <div className="form__separation form__separation--clear-margin-top">{t('term')}:</div>

                <label htmlFor="installationDate" className="form-field__label">{t('forms:installationDate')}</label>
                <div className="form-field form-field--clear-margin flex flex--space-between flex--center">
                    <Field
                        name="installationDate"
                        wrapperClassName={'form-field--half'}
                        component={DatePickerField}
                        type="text"
                        placeholder={t('forms:date')}
                        // label={t('forms:installationDate')}
                        validate={hasSelectedDate ? [Validators.dateIsFuture] : undefined}
                    />
                    <Field
                        name="installationDate"
                        wrapperClassName={'form-field--half'}
                        component={TimePickerField}
                        type="text"
                        placeholder={t('forms:hour')}
                        validate={hasSelectedDate ? [Validators.dateIsFuture] : undefined}
                    />
                </div>

                <Field
                    name="technicianUser"
                    component={SelectField}
                    options={terminalFitterList}
                    type="text"
                    placeholder={t('technician')}
                    label={t('forms:assignedTechnician') + (!hasSelectedDate ? ' (' + t('forms:selectDateRequiredFirst') + ')' : '')}
                    validate={[Validators.required, ValidatorsTerminalls.policyDateIsGreater]}
                />
            </form>
        );
    }
}

function mapStateToProps(state: RootState) {
    return {
        responseError: state.errorStore.responseError.data,
        terminalFitterList: TerminalInstallationSelectors.getAvailableTechnicianUserListForSelect(state),
        activelanguage: state.viewManagementStore.activeLanguage,
        installationDateForm: state.form.terminalInstallationListSetDateForm
    };
}

function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        getUserList: (queryParams?: Array<{ key: any; value: any }>) => dispatch(UserModule.Actions.getUserList(queryParams)),
        getUserById: (id: number) => dispatch(UserModule.Actions.getUserById(id))
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation(['forms', 'errors', 'dictionary', 'carDetails']),
    reduxForm({
        form: 'terminalInstallationListSetDateForm',
        enableReinitialize: true,
        keepDirtyOnReinitialize: true
    })
)(TerminalInstallationListSetDateForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/Layout/Form/TerminalInstallationListSetDateForm.tsx